<template>
    <v-expansion-panel>
        <v-expansion-panel-header>
            <template v-slot:default="{ open }">
                <v-row no-gutters>
                    <v-col cols="12" class="title">
                        II. Dane do ubezpieczenia
                    </v-col>
                </v-row>
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <Insurance :insuranceTypeErrors="insuranceTypeErrors" />
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
  import Insurance from "./Insurance";

  export default {
    name: "InsuranceData",
    components: {Insurance},
    data: () => ({
    }),
    props: [
      'insuranceTypeErrors'
    ]
  }
</script>

<style scoped>
    >>> .v-label {
        height: unset !important;
    }
</style>
